export default {
	title: 'Portfolio',
	description: 'All my Gerositus projects',
	actions: {
		back_to_this: 'Back to portfolio'
	}
};
